import React from 'react';
import { Arrow } from 'react-konva';
import useLinkConnectionOperations from 'components/canvas/hooks/use-link-connection-operations';
import { useLinkArrowState } from 'components/canvas/hooks/use-link-arrow-state';
import { isDefined } from 'utils/js';
import { color } from 'styles/settings';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import { useNodeLinking } from 'state/canvas/node-linking';

interface LinkArrowProps {
  surface: string;
}

function LinkArrowComponent({ surface }: LinkArrowProps) {
  const [{ linkStartPosition }, { removeLinkArrow }] = useNodeLinking(surface);

  const { calculateLinkConnectionPosition } = useLinkConnectionOperations(
    surface,
  );

  const { getSelectedNode } = useSelectedNodeOperations();

  const selectedNode = getSelectedNode();

  const start = selectedNode
    ? calculateLinkConnectionPosition(selectedNode as string)
    : (linkStartPosition as any);

  const { end } = useLinkArrowState({
    start,
    removeArrow: removeLinkArrow,
    surface,
  });

  if (start && isDefined(end.x) && isDefined(end.y)) {
    return (
      <Arrow
        points={[start.x, start.y, end.x, end.y]}
        strokeWidth={2}
        fill={color.brand.blue}
        stroke={color.brand.blue}
      />
    );
  }

  return null;
}

export default function LinkArrow(props: LinkArrowProps) {
  const [{ isLinkArrowShown }] = useNodeLinking(props.surface);

  return isLinkArrowShown ? <LinkArrowComponent {...props} /> : null;
}
